import PrescrizioniRipetibili from "./components/PrescrizioniRipetibili.vue";
import PrenotazioniAgenda from "./components/PrenotazioniAgenda.vue";
import PrenotazioniAgendaAppuntamenti from "./components/PrenotazioniAgendaAppuntamenti.vue";

export default {
    PrescrizioniRipetibili,
    PrenotazioniAgenda,
    PrenotazioniAgendaAppuntamenti,
};
